module.exports = "/_next/static/images/ExtensibleDocumentation-fddf0640c00cb86c5b5441e3bb696e51.webp";